import React from "react";

const ConfirmWorkMenuModal = ({ isOpen, onConfirm, onCancel, clientName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md shadow-lg p-6 w-80">
        <h3 className="text-lg font-bold text-gray-800 mb-4">
          Conferma Manutenzione Menu
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          Sei sicuro di voler mettere in manutenzione il menu?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            Conferma
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmWorkMenuModal;
